import axios from 'axios';
import { RAAGAS_BOT_LIST_URL, RAAGAS_CONFIG_URL, RAAGAS_CREATE_BOT_URL, RAAGAS_CREATE_USER_URL, RAAGAS_DELETE_URL, RAAGAS_FILE_LIST_URL, RAAGAS_FILE_UPLOAD_URL, RAAGAS_PIPELINE_URL, RAAGAS_QUERY_URL, RAAGAS_USER_LIST_URL, STORAGE_DELETE_URL, STORAGE_DOWNLOAD_URL, STORAGE_LIST_URL, STORAGE_SUMMARIZE_URL, STORAGE_UPLOAD_URL } from '../../utils/apiUrls';
import { deleteRequest, getRequest, postRequest, uploadRequest } from '../../utils/http';



export interface File {
  bucket_name: string;
  folder_path: string;
  raw_file: string;
  ext_file: string;
  file_path: string;
  file_name: string;
  file_size_kb: number;
  file_updated_date: string;
}

export interface FileListResponse {
  folders_files: File[];
}

export interface UserInfo {
  first_name: string;
  last_name: string;
  user_email: string;
  user_id: string;
}

export interface RagUser {
  user_id: string;
  role: string;
  organization: string;
}

export interface RagBot {
  bot_id: string,
  bot_name: string,
  bot_description: string
}

export interface RagResponse {
  response: string,
  source: string
}

export const fileList = async (user: UserInfo): Promise<FileListResponse> => {
  try {
    const response = await postRequest(STORAGE_LIST_URL, {
      "first_name": user.first_name,
      "last_name": user.last_name,
      "user_email": user.user_email,
      "user_id": user.user_id
    });
    return response;
  }
  catch (error) {
    console.error('Error calling Storage API:', error);
    throw error;
  }
}

export const fileDelete = async (target: File, user: UserInfo): Promise<any> => {
  try {
    const response = await deleteRequest(STORAGE_DELETE_URL, {
      "bucket_name": target.bucket_name,
      "file_name": target.file_name,
      "file_path": target.file_path,
      "folder_path": target.folder_path,
      "user_id": user.user_id
    });
    return response;
  }
  catch (error) {
    console.error('Error calling Storage API', error);
    throw error;
  }
}

export const fileUpload = async (file: any, user: UserInfo): Promise<any> => {
  try {
    const response = await uploadRequest(`${STORAGE_UPLOAD_URL}/${user.user_id}`, file);
    return response;
  }
  catch (error) {
    console.error('Error calling Storage API', error);
    throw error;
  }
}

export const fileSummarize = async (target: File, user: UserInfo): Promise<any> => {
  try {
    const response = await postRequest(STORAGE_SUMMARIZE_URL, {
      "path": {
        "bucket_name": target.bucket_name,
        "file_name": target.file_name,
        "file_path": target.file_path,
        "folder_path": target.folder_path,
        "user_id": user.user_id
      },
      "summary_inputs": {
        "model": "text-bison",
        "prompt": "Summarize the file's text in 3 points in english. Each point must be separated with '*'. Do not use any other form of bullet point."
      }
    });
    return response.summary;
  }
  catch (error) {
    console.error('Error calling Storage API', error);
    throw error;
  }
}

export const fileDownload = async (target: File, user: UserInfo): Promise<any> => {
  try {
    const response = await postRequest(STORAGE_DOWNLOAD_URL, {
      "bucket_name": target.bucket_name,
      "file_name": target.file_name,
      "file_path": target.file_path,
      "folder_path": target.folder_path,
      "user_id": user.user_id
    })
    return response.download_url;
  }
  catch (error) {
    console.error('Error calling Storage API', error);
    throw error;
  }
}

export const checkRagaasUser = async (user: UserInfo): Promise<any> => {
  try {
    const response = await getRequest(`${RAAGAS_USER_LIST_URL}/?login_user_id=Secure%20Storage%20Admin`);
    console.log(response);
    for (const ragUser of response) {
      if (ragUser.user_id == user.user_id) {
        console.log("User exists");
        return response;
      }
    }

    const newUser: RagUser = {
      user_id: user.user_id,
      role: "admin",
      organization: "Brightspeed CC"
    }

    const createResponse = await postRequest(`${RAAGAS_CREATE_USER_URL}?login_user_id=Secure%20Storage%20Admin`, {
      "organization": newUser.organization,
      "password": newUser.user_id,
      "role": newUser.role,
      "user_id": newUser.user_id
    })
    console.log(createResponse);
    return createResponse;
  }
  catch (error) {
    console.error('Error fetching RAAGAS users', error);
    throw error;
  }
}

export const checkRagaasBot = async (user: UserInfo): Promise<any> => {
  try {
    const response = await getRequest(`${RAAGAS_BOT_LIST_URL}?login_user_id=${user.user_id}`);
    console.log(response);

    if (!(response == "No apps found")) {
      const filtered = response.filter((entry: RagBot) => entry.bot_name == `${user.first_name} ${user.last_name} Storage Bot`);

      if (filtered.length < 1) {
        const createResponse = await postRequest(`${RAAGAS_CREATE_BOT_URL}?login_user_id=${user.user_id}`, {
          "botDescription": "Redis vector db with index schema config",
          "botName": `${user.first_name} ${user.last_name} Storage Bot`,
          "bot_configs": {
            "chunk_overlap": 50,
            "chunk_size": 500,
            "configuration_name": `redis_index_${user.user_id}`,
            "embedding_model": "textembedding-gecko_001",
            "index_schema": "text:\n- name: source\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: title\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: source_link\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: content\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\nvector:\n- algorithm: FLAT\n  datatype: FLOAT32\n  dims: 768\n  distance_metric: COSINE\n  name: content_vector",
            "vector_database": "redis"
          },
          "organization": "Brightspeed CC"
        });
        console.log(createResponse);
      }
    }
    else {
      const createResponse = await postRequest(`${RAAGAS_CREATE_BOT_URL}?login_user_id=${user.user_id}`, {
        "botDescription": "Redis vector db with index schema config",
        "botName": `${user.first_name} ${user.last_name} Storage Bot`,
        "bot_configs": {
          "chunk_overlap": 50,
          "chunk_size": 500,
          "configuration_name": `redis_index_${user.user_id}`,
          "embedding_model": "textembedding-gecko_001",
          "index_schema": "text:\n- name: source\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: title\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: source_link\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\n- name: content\n  no_index: false\n  no_stem: false\n  sortable: false\n  weight: 1\n  withsuffixtrie: false\nvector:\n- algorithm: FLAT\n  datatype: FLOAT32\n  dims: 768\n  distance_metric: COSINE\n  name: content_vector",
          "vector_database": "redis"
        },
        "organization": "Brightspeed CC"
      });
      console.log(createResponse);
    }

    return response
  }
  catch (error) {
    console.error('Error fetching RAAGAS bots', error);
    throw error;
  }
}

const checkRagaasFiles = async (user: UserInfo, bot: RagBot): Promise<any> => {
  try {

    let response = "";
    try {
      response = await getRequest(`${RAAGAS_FILE_LIST_URL}${bot.bot_id}?login_user_id=${user.user_id}`);
    } catch (error) {
      console.log("Bot Files not retrieved");
    }
    const storedFiles = await fileList(user);
    console.log(response);

    const rawFiles = [];
    for (const file of storedFiles.folders_files) {
      if (file.raw_file == "true")
        rawFiles.push(file);
    }
    let uploadCount = 0;
    for (const file of rawFiles) {
      if (!(response.includes(file.file_name))) {
        uploadCount += 1;
        console.log(file.file_name);
        const downloadURL = await fileDownload(file, user);
        const downloadResponse = await fetch(downloadURL);
        const downloadedFile = await downloadResponse.blob();
        const uploadFile = new File([downloadedFile], file.file_name);
        const formData = new FormData();
        formData.append("files", uploadFile);
        for (var data of formData.entries()) {
          console.log("Form Data:" + data);
          console.log(data);
        }

        const uploadResponse = await uploadRequest(`${RAAGAS_FILE_UPLOAD_URL}${bot.bot_id}/config/redis_index_${user.user_id}/app/Testing_Application?login_user_id=${user.user_id}`, formData);
        console.log(uploadResponse);
      }
    }

    const getNames = (rawFile: File): string => {
      return rawFile.file_name;
    }
    const fileNames = rawFiles.map(getNames)
    for (const file of response) {
      if (!(fileNames.includes(file))) {
        console.log("Deleting ", file);
        const deleteResponse = deleteRequest(`${RAAGAS_DELETE_URL}?botId=${bot.bot_id}&filename=${file}&login_user_id=${user.user_id}`, {});
        console.log(deleteResponse);
      }
    }

    if (uploadCount > 0) {
      const pipeResponse = await postRequest(`${RAAGAS_PIPELINE_URL}`, {
        "DISPLAY_NAME": "ragaas_pipeline",
        "LOCATION": "us-east4",
        "PIPELINE_ROOT": "gs://ragaas_process_bucket/pipeline-root",
        "SERVICE_ACCOUNT": "ccai-genai-gar-dv@app-cca-genai-cn-dv-g009.iam.gserviceaccount.com",
        "network": "projects/638005491345/global/networks/dv-vc",
        "para_val": {
          "batch_id": Date.now(),
          "bucket_name": "ragaas_process_bucket",
          "config_path": "usecase_config_host_new.json",
          "environment": "dev",
          "num_nodes": uploadCount
        },
        "reserved_ip_ranges": [
          "ge4-dv-appccagenai-gpsc-sn"
        ],
        "template_path": "https://us-east4-kfp.pkg.dev/app-cca-genai-cn-dv-g009/main-artifact-registry/document-processing-pipeline/latest"
      })
      console.log(pipeResponse);
    }
  }
  catch (error) {
    console.error('Error fetching RAAGAS files', error);
    throw error;
  }
}

export const syncRagaas = async (user: UserInfo): Promise<any> => {
  await checkRagaasUser(user);
  let botResponse = await checkRagaasBot(user);
  if (botResponse == "No apps found" || botResponse.filter((entry: RagBot) => entry.bot_name == `${user.first_name} ${user.last_name} Storage Bot`).length < 1)
    botResponse = await checkRagaasBot(user);

  const bot: RagBot = botResponse[0];
  await checkRagaasFiles(user, bot);
}

const getConfig = async (user: UserInfo, bot: RagBot): Promise<any> => {
  const response = await getRequest(`${RAAGAS_CONFIG_URL}${bot.bot_id}?login_user_id=${user.user_id}`);
  console.log(response);
  return response.config_collection[0].configuration_name;
}

export const queryRagaas = async (user: UserInfo, prompt: string, bot: RagBot): Promise<any> => {

  const config = await getConfig(user, bot);

  const queryResponse: RagResponse = await postRequest(`${RAAGAS_QUERY_URL}?login_user_id=${user.user_id}`, {

    "app_name": "Testing_Application",
    "botId": `${bot.bot_id}`,
    "config_name": `${config}`,
    "llm_name": "gemini-1.5-pro-001",
    "query": `${prompt}\nAnswer must be in Markdown format.`,
    "temperature": 1,
    "threshold": 0.75,
    "top_p": 1

  })

  return queryResponse;

}

export const textToSpeech = async (text: string): Promise<any> => {


  const speechResponse = await axios({
    method: "POST",
    url: "http://localhost:3001/tts",
    data: { text }
  });

  return speechResponse;

}